import { COBStep, getCommonReachableSteps } from "../ClientOnboarding.common.utils";
export function getVendorGradientStyle(branding) {
  return {
    background: "linear-gradient(315deg, var(--bg-gradient-color-2, ".concat(branding.backgroundGradientEnd, ") 0%, var(--bg-gradient-color-1, ").concat(branding.backgroundGradientStart, ") 100%)")
  };
}
export function getReachableInnerSteps(relationship) {
  return [COBStep.introduction, ...getCommonReachableSteps(relationship)];
}
export function getNextStepButtonText(step, relationship) {
  const reachableSteps = getReachableInnerSteps(relationship);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    return 'Next';
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    return 'Sign & approve';
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add a payment method';
  }
  return 'Next';
}